import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';

// material-ui icons
import MoreVert from 'Layouts/Layout/images/menuleft.png';
import ViewList from 'Layouts/Layout/images/menuright.png';

// core components
import CustomIconButton from 'Common/CustomButtons/IconButton.jsx';

import { headerStyle } from './styles.jsx';

function Minimize({ ...props }) {
    const { classes } = props;
    const sidebarMinimize = classes.sidebarMinimize;
    return (
        <Hidden smDown>
            <div className={sidebarMinimize}>
                {props.miniActive ? (
                    <CustomIconButton
                        color="white"
                        onClick={props.sidebarMinimize}
                        customClass="colapseSidebarBtn"
                    >
                        <img src={ViewList} alt="viewlist" />
                    </CustomIconButton>
                ) : (
                    <CustomIconButton
                        color="white"
                        onClick={props.sidebarMinimize}
                        customClass="colapseSidebarBtn"
                    >
                        <img src={MoreVert} alt="MoreVert" />
                    </CustomIconButton>
                )}
            </div>
        </Hidden>
    );
}

Minimize.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
    miniActive: PropTypes.bool,
    routes: PropTypes.array,
    location: PropTypes.any,
    sidebarMinimize: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
    logout: PropTypes.func,
};

export default withStyles(headerStyle)(Minimize);



// WEBPACK FOOTER //
// ./src/common/Header/Minimize.jsx